import { PageSuspense } from "ui/@page/ui/page-suspense"
import { TonConnectProvider } from "@/providers/TonConnectProvider"
import {
  AchievementsPage,
  AltarActivityLogsPage,
  AltarPage,
  AltarWrapperPage,
  AuctionHistoryPage,
  AuctionPage,
  BalanceHistoryPage,
  BossLayout,
  BossLeaderboardPage,
  BossPage,
  BossRoomPage,
  BossArenaPage,
  BossArenaAttackPage,
  BuyGoldPage,
  ClanBankPage,
  ClanChatPage,
  ClanForm,
  ClanHutPagePage,
  ClanLeaderboardsPage,
  ClanMapPage,
  ClansHomePage,
  ClansLayoutPage,
  ClansPage,
  CompleteStakingPage,
  CraftPage,
  DarkHeroPage,
  DepositPage,
  ExamineClanPage,
  ExpeditionsPage,
  HeroWrapperPage,
  HomePage,
  InitWithdrawalPage,
  InventoryPage,
  InventoryWrapperPage,
  LeaderboardPage,
  LeaderboardPersonalPage,
  MineEntrancePage,
  MineGamePage,
  PointsLeaderboardPage,
  ProfessionsPage,
  PurchaseStatusPage,
  QuestsDailyRewardsPage,
  SaleChestPage,
  QuestsGuidePage,
  QuestsListPage,
  QuestsMissionsPage,
  QuestsWrapperPage,
  ReferralCommissionsPage,
  ReferralDetailsPage,
  ReferralFriendsPage,
  ReferralsWrapperPage,
  StakingActivePlansPage,
  StakingPage,
  StoreOffersPage,
  StorePage,
  StoreTonPage,
  StoreWrapperPage,
  TonShopWrapperPage,
  TrainingPage,
  WalletWrapperPage,
  WithdrawalPage
} from "./pages"

const walletPaths = {
  path: "wallet",
  element: <PageSuspense style="green" Component={WalletWrapperPage} />,
  children: [
    { path: "buy-gold", element: <BuyGoldPage /> },
    { path: "deposit", element: <DepositPage /> },
    { path: "withdrawal", element: <WithdrawalPage /> },
    { path: "balance-history", element: <BalanceHistoryPage /> },
    {
      path: "staking",
      children: [
        { index: true, element: <StakingPage /> },
        {
          path: "active-plans",
          element: <StakingActivePlansPage />
        }
      ]
    }
  ]
}

const clanPaths = {
  path: "clans",
  element: <PageSuspense style="clans" Component={ClansLayoutPage} />,
  children: [
    { index: true, element: <ClansHomePage /> },
    { path: "clans-page", element: <ClansPage /> },
    { path: "form/:mode", element: <ClanForm /> },
    { path: "clan-hut", element: <ClanHutPagePage /> },
    { path: "clan/:clanId", element: <ExamineClanPage /> },
    { path: "clan/:clanId/view", element: <ClanMapPage /> },
    { path: "bank", element: <ClanBankPage /> },
    {
      path: "altar",
      element: <AltarWrapperPage />,
      children: [
        { index: true, element: <AltarPage /> },
        { path: "logs", element: <AltarActivityLogsPage /> }
      ]
    }
  ]
}

const clanChatPath = {
  path: "clans/chat",
  element: <PageSuspense style="clans" Component={ClansLayoutPage} />,
  children: [{ index: true, element: <ClanChatPage /> }]
}

export const routerPathsCommon = [
  {
    path: "",
    element: <PageSuspense Component={HomePage} />
  },
  {
    path: "sale-chest",
    element: <PageSuspense style="dark-blue" Component={SaleChestPage} />
  },
  {
    path: "inventory",
    element: (
      <PageSuspense style="inventory" Component={InventoryWrapperPage} />
    ),
    children: [
      {
        index: true,
        element: <InventoryPage />
      },
      { path: "craft", element: <CraftPage /> }
    ]
  },
  {
    path: "store",
    element: <PageSuspense style="inventory" Component={StoreWrapperPage} />,
    children: [
      {
        index: true,
        element: <StorePage />
      },
      {
        path: "ton",
        element: <StoreTonPage />
      },
      {
        path: "offers",
        element: <StoreOffersPage />
      },
      {
        path: "auction",
        element: <AuctionPage />
      },
      {
        path: "auction/history",
        element: <AuctionHistoryPage />
      }
    ]
  },
  {
    path: "referrals",
    element: <PageSuspense style="purple" Component={ReferralsWrapperPage} />,
    children: [
      {
        path: "details",
        element: <ReferralDetailsPage />
      },
      { path: "commissions", element: <ReferralCommissionsPage /> },
      { path: "friends", element: <ReferralFriendsPage /> }
    ]
  },
  {
    path: "quests",
    element: <PageSuspense style="quests" Component={QuestsWrapperPage} />,
    children: [
      { index: true, element: <QuestsListPage /> },
      {
        path: "daily",
        element: <QuestsDailyRewardsPage />
      },
      { path: "guides", element: <QuestsGuidePage /> },
      { path: "missions", element: <QuestsMissionsPage /> }
    ]
  },
  {
    path: "adventures",
    children: [
      {
        path: "expeditions",
        element: <PageSuspense Component={ExpeditionsPage} />
      }
    ]
  },
  {
    path: "hero",
    element: <PageSuspense style="quests" Component={HeroWrapperPage} />,
    children: [
      { path: "training", element: <TrainingPage /> },
      { path: "professions", element: <ProfessionsPage /> },
      { path: "achievements", element: <AchievementsPage /> }
    ]
  },
  {
    path: "mine",
    children: [
      {
        path: "entrance",
        element: <PageSuspense Component={MineEntrancePage} />
      },
      {
        path: "game",
        element: <PageSuspense Component={MineGamePage} />
      }
    ]
  },
  walletPaths,
  clanPaths
]

export const routerPathsUnder = [
  {
    element: <BossLayout />,
    children: [
      {
        path: "",
        element: <PageSuspense Component={BossPage} />
      },
      {
        path: "hero",
        element: <PageSuspense style="quests" Component={DarkHeroPage} />
      },
      {
        path: "boss",
        element: <PageSuspense Component={BossRoomPage} />
      }
    ]
  },
  {
    path: "inventory",
    element: <PageSuspense style="quests" Component={InventoryWrapperPage} />,
    children: [{ index: true, element: <InventoryPage /> }]
  },
  {
    element: <PageSuspense style="inventory" Component={TonShopWrapperPage} />,
    children: [
      {
        path: "ton-shop",
        element: <StoreTonPage />
      },
      {
        path: "store/auction",
        element: <AuctionPage />
      },
      {
        path: "store/auction/history",
        element: <AuctionHistoryPage />
      }
    ]
  },
  walletPaths,
  clanPaths
]

export const routerOutsidePathsCommon = [
  clanChatPath,
  {
    path: "clans/leaderboard",
    element: <PageSuspense style="clans" Component={ClansLayoutPage} />,
    children: [{ index: true, element: <ClanLeaderboardsPage /> }]
  },
  {
    path: "leaderboard",
    children: [
      {
        index: true,
        element: <PageSuspense Component={LeaderboardPage} />
      },
      {
        path: ":userId",
        element: <PageSuspense Component={LeaderboardPersonalPage} />
      }
    ]
  },
  {
    path: "quests/missions/points-leaderboard",
    element: <PageSuspense Component={PointsLeaderboardPage} />
  },
  {
    path: "purchase-status",
    element: <PageSuspense style="green" Component={PurchaseStatusPage} />
  },
  {
    path: "wallet/withdrawal/init",
    element: (
      <PageSuspense style="green">
        <TonConnectProvider>
          <InitWithdrawalPage />
        </TonConnectProvider>
      </PageSuspense>
    )
  },
  {
    path: "wallet/staking/complete",
    element: <PageSuspense style="green" Component={CompleteStakingPage} />
  }
]

export const routerOutsidePathsUnder = [
  clanChatPath,
  {
    path: "boss/leaderboard",
    children: [
      {
        index: true,
        element: <PageSuspense Component={BossLeaderboardPage} />
      }
    ]
  },
  {
    path: "arena",
    element: <PageSuspense Component={BossArenaPage} />
  },
  {
    path: "arena/attack",
    element: <PageSuspense Component={BossArenaAttackPage} />
  },
  {
    path: "purchase-status",
    element: <PageSuspense style="green" Component={PurchaseStatusPage} />
  },
  {
    path: "wallet/withdrawal/init",
    element: (
      <PageSuspense style="green">
        <TonConnectProvider>
          <InitWithdrawalPage />
        </TonConnectProvider>
      </PageSuspense>
    )
  },
  {
    path: "wallet/staking/complete",
    element: <PageSuspense style="green" Component={CompleteStakingPage} />
  }
]
